import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from "react";
import { Flex, Button, Heading } from "@chakra-ui/react";
import { Filter } from "../../../types/General/Filter";
import { borderRadius, borderStyle } from "../../../utils/styles/styles";

interface AnalysisFilterProps {
  title: string;
  filterChildren?: ReactNode;
  filters?: Filter[];
  dataTable: any[];
  setFilteredTable: (data: any) => void;
  setShowTable: Dispatch<SetStateAction<boolean>>;
  setIsSearching: Dispatch<SetStateAction<boolean>>;
  filterRules: Array<() => boolean>;
  setIsLoaded: Dispatch<SetStateAction<boolean>>;
}

const AnalysisFilter: FC<AnalysisFilterProps> = ({
  title,
  filterChildren,
  filters = [],
  dataTable,
  setFilteredTable,
  setShowTable,
  setIsSearching,
  filterRules,
  setIsLoaded,
}) => {
  const [originalDataTable, setOriginalDataTable] = useState<any[]>(dataTable);
  useEffect(() => {
    setOriginalDataTable(dataTable);
  }, [dataTable]);

  const handleSearchCall = useCallback(() => {
    for (const rule of filterRules) {
      if (rule()) {
        setShowTable(false);
        return;
      }
    }

    setIsSearching(true);
    setShowTable(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, originalDataTable, setFilteredTable, setShowTable]);

  const handleCleanFilters = () => {
    filters.forEach((filter) => filter.setValue(""));
    setFilteredTable(originalDataTable);
    setShowTable(false);
    setIsSearching(true);
    setIsLoaded(false);
  };

  return (
    <Flex
      direction="column"
      gap={4}
      bgColor="gray.200"
      border={borderStyle}
      borderRadius={borderRadius}
      borderBottomRadius={0}
      p="4"
    >
      <Heading as="h3" fontSize="2xl">
        {title}
      </Heading>

      <Flex gap={4} wrap="wrap">
        <Flex flex="1" gap={4} wrap="wrap">
          {filterChildren}
        </Flex>

        <Flex gap={2} mt={8}>
          <Button size="md" fontWeight="bold" onClick={handleSearchCall}>
            Gerar tabela
          </Button>

          <Button
            variant="secondary"
            size="md"
            fontWeight="bold"
            onClick={handleCleanFilters}
          >
            Limpar
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AnalysisFilter;
